import {createAction, props} from '@ngrx/store';
import {IStore} from '../../../shared/shared-models/store/store';
import {ISupplier} from '../../../shared/shared-models/stock/suppliers';
import {IDebtorDetails} from '../../quotes/models/debtors';
import {IStorage} from '../../../shared/shared-models/storage/storage';
import {IFirebaseQuery} from '../../../shared/shared-models/firebase/firebase-queries';
import {IMessage, IMessageAutoOrderUpdate, MessageType} from '../models';
import {IDepartment} from 'src/app/shared/shared-models/stock/departments';
import {ISharedStoreSettings} from 'src/app/shared/shared-models/firebase/shared-store-settings';
import {IColleagues} from '../../user-access/models';
import {IGlobalError} from 'src/app/shared/shared-components/components/global-error-display/models/global-error';
import {TLineColour} from '../../settings-new/models';

// ====================================================================================================
// Get Store
// ====================================================================================================
//#region Get Store
export const getStoreSuppliersByUserSelectedStore = createAction(
  '[Core Shared][Suppliers] Get Store Suppliers By User Selected Store',
  props<{dispatch: boolean}>(),
);

export const getStoreSuppliersByStore = createAction(
  '[Core Shared][Suppliers] Get Store Suppliers By Store',
  props<{store: IStore}>(),
);

export const getStoreSuppliersByStoreSuccess = createAction(
  '[Core Shared][Suppliers] Get Store Suppliers By Store Success',
  props<{suppliers: Record<string, ISupplier>, store: IStore}>(),
);

export const getStoreSuppliersByStoreFailure = createAction(
  '[Core Shared][Suppliers] Get Store Suppliers By Store Failure',
  props<{error: IGlobalError}>(),
);

export const getStoreDebtorsByUserSelectedStore = createAction(
  '[Core Shared][Debtors] Get Store Debtors By User Selected Store',
  props<{dispatch: boolean}>(),
);

export const getStoreDebtorsByStore = createAction(
  '[Core Shared][Debtors] Get Store Debtors By Store',
  props<{store: IStore}>(),
);

export const getStoreDebtorsByStoreSuccess = createAction(
  '[Core Shared][Debtors] Get Store Debtors By Store Success',
  props<{debtors: Record<string, IDebtorDetails & {debtorId?: string; isDebtorSelected?: boolean}>, store: IStore}>(),
);

export const getStoreDebtorsByStoreFailure = createAction(
  '[Core Shared][Debtors] Get Store Debtors By Store Failure',
  props<{error: IGlobalError}>(),
);

export const fetchStoreDepartments = createAction(
  '[Shared State] Fetch Store Departments',
);

export const fetchStoreDepartmentsSuccess = createAction(
  '[Shared State] Fetch Store Departments Success',
  props<{storeId: string; departments: IDepartment[]; storeSettings: ISharedStoreSettings}>(),
);

export const fetchStoreDepartmentsFailure = createAction(
  '[Shared State] Fetch Store Departments Failure',
  props<{storeId: string; error: IGlobalError}>(),
);

// ====================================================================================================
// Line Colour
// ====================================================================================================
export const getLineColour = createAction(
  '[Core Shared][Line Colour] Get Line Colour',
);

export const getLineColourSuccess = createAction(
  '[Core Shared][Line Colour] Get Line Colour Success',
  props<{store: IStore; lineColour: TLineColour}>(),
);

export const getLineColourFailure = createAction(
  '[Core Shared][Line Colour] Get Line Colour Failure',
  props<{store: IStore; error: IGlobalError}>(),
);
//endregion

// ====================================================================================================
// Get Colleagues
// ====================================================================================================
//#region Get Colleagues
export const getColleagues = createAction(
  '[Core Shared][Colleagues] Get Colleagues',
);

export const getColleaguesSuccess = createAction(
  '[Core Shared][Colleagues] Get Colleagues Success',
  props<{users: IColleagues}>(),
);

export const getColleaguesFailure = createAction(
  '[Core Shared][Colleagues] Get Colleagues Failure',
  props<{error: IGlobalError}>(),
);

export const killColleaguesService = createAction(
  '[Core Shared][Colleagues] Kill Colleagues Service',
);
//endregion

// ====================================================================================================
// Firestore Storage
// ====================================================================================================
//region Firestore Storage
export const getDownloadUrlFromStorage = createAction(
  '[Core Shared][Storage] Get Download URL from Storage',
  props<{storage: IStorage}>(),
);

export const getDownloadUrlFromStorageSuccess = createAction(
  '[Core Shared][Storage] Get Download URL from Storage Success',
  props<{storage: IStorage}>(),
);

export const getDownloadUrlFromStorageFailure = createAction(
  '[Core Shared][Storage] Get Download URL from Storage Failure',
  props<{error: IGlobalError}>(),
);

export const clearDownloadUrlFromStorage = createAction(
  '[Core Shared][Storage] Clear Download URL from Storage',
);
//endregion


// ====================================================================================================
// Messages From App
// ====================================================================================================
//#region Messages From App
export const getMessagesFromAppForAutoOrderUpdates = createAction(
  '[Core Shared][Messages] Get Messages From App for Auto Order Updates',
  props<{messageType: MessageType, queries: IFirebaseQuery[]}>(),
);

export const getMessagesFromAppForAutoOrderUpdatesSuccess = createAction(
  '[Core Shared][Messages] Get Messages From App for Auto Order Updates Success',
  props<{
    messageType: MessageType,
    queries: IFirebaseQuery[],
    store: IStore,
    messages: IMessage<IMessageAutoOrderUpdate[]>[]
  }>(),
);

export const getMessagesFromAppForAutoOrderUpdatesFailure = createAction(
  '[Core Shared][Messages] Get Messages From App for Auto Order Updates Failure',
  props<{error: IGlobalError}>(),
);

export const deleteOldMessages = createAction(
  '[Core Shared][Messages] Delete Old Messages From User Messages ',
  props<{messageIds: string[]}>(),
);
//endregion

//#region Version
export const getVersion = createAction(
  '[Core Shared][Version] Get Version',
);

export const checkVersionOnAppLoad = createAction(
  '[Shared] Check Version On App Load'
);

export const setInitialVersion = createAction(
  '[Core Shared][Version] Set Initial Version',
  props<{version: string}>(),
);

export const setChangedVersion = createAction(
  '[Core Shared][Version] Set Changed Version',
  props<{version: string}>(),
);
//endregion


